import { Navigate, useParams } from 'react-router-dom';
import { DEFAULT_REPORT_SLUG, reportModelBySlug } from '@trinetra/shared';
import AlertInvestigationPage from './AlertInvestigationPage';

/**
 * `/reports/:model` — one page per AI model. All eight share the investigation
 * page's fetching, filtering and per-model columns; only the model is pinned.
 */
export default function ReportPage() {
  const { model: slug } = useParams();
  const entry = reportModelBySlug(slug);

  if (!entry) return <Navigate to={`/reports/${DEFAULT_REPORT_SLUG}`} replace />;

  // `key` remounts on model change so filters/paging don't leak between reports.
  return <AlertInvestigationPage key={entry.key} lockedModel={entry.key} />;
}
